import React, { Component } from 'react'
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Box,
    Grid,
    Tabs,
    FormControl,
    FormControlLabel,
    Checkbox,
    Typography,
    TextField,
    FormGroup,
    Select,
    MenuItem,
    FormHelperText,
} from '@mui/material'
import LoadingDefault from '../../../Elements/Loading/LoadingDefault'
import { faExclamationCircle } from '@fortawesome/pro-duotone-svg-icons/faExclamationCircle'
import { faPlus } from '@fortawesome/pro-duotone-svg-icons/faPlus'
import { faSave } from '@fortawesome/pro-duotone-svg-icons/faSave'
import { faTrashAlt } from '@fortawesome/pro-duotone-svg-icons/faTrashAlt'
import { faAngleDown } from '@fortawesome/pro-duotone-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import LocaleName from '../../../Elements/Translations/LocaleName'
import SelectList from '../../../Elements/SelectList'
import DisplayCustomViewForm from '../../../Form/DisplayCustomViewForm'
import NivoSchemeSelector from '../../../Form/NivoSchemeSelector'
import BlockFormTemplateSelect from './BlockFormTemplateSelect'
import BlockFormPercentageChartSetting from './BlockFormPercentageChartSetting'
import BlockTabQueries from './BlockTabQueries'
import BlockSortSettings from './BlockSortSettings'
import ObjectCreatedInfo from '../../../Elements/ObjectCreatedInfo'
import DossierQuerySelect from '../../../Elements/Select/DossierQuerySelect'
import ConfirmDeleteDialog from '../../../Form/ConfirmDeleteDialog'
import AppDialog from '@/Components/AppDialog/AppDialog'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'
import { StyledVerticalTab } from '@/Components/Elements/StyledComponents/Tabs'
import TabPanel from '@/Components/Elements/TabPanel/TabPanel'
import { brandedTokens } from '@/theme/tokens'
import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'

class BlockForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            defDossiers: [],
            dossierQuery: false,
            countLinkDefDossier: null,
            countLinkDefDossierSec: null,
            dossierQueries: [],
            delete: false,
            errors: [],
            views: [],
            sort:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.sort
                    ? this.props.item.settings.sort
                    : null,
            view_name:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.view_name
                    : 'list',
            authKey:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.authKey
                    : null,
            authToken:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.authToken
                    : null,
            dashboardId:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.dashboardId
                    : null,
            showAdd:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.show_add
                    : false,
            tabQueries:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.tab_queries
                    : false,
            template:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.template
                    : null,
            templateOptions:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.templateOptions
                    : {},
            pie_charts:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.pie_charts
                    : null,
            list_field:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.list_field
                    : null,
            count_list_field:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.count_list_field
                    : null,
            count_link_field:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.count_link_field
                    : null,
            count_link_field_sec:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.count_link_field_sec
                    : null,
            link_field:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.link_field
                    : null,
            origin_link_field:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.origin_link_field
                    : null,
            scheme:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.scheme
                    : null,
            date_field:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.date_field
                    : null,
            sum_field:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.sum_field
                    : null,
            limit:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.limit
                    : 10,
            carousel:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.carousel
                    : false,
            use_creation_date:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.use_creation_date
                    : false,
            group_format:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.group_format
                    : null,
            date_format:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.date_format
                    : null,
            chart_format:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.chart_format
                    : null,
            chart_layout:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.chart_layout
                    : null,
            chart_identifier:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.chart_identifier
                    : null,
            table_layout:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.table_layout
                    : null,
            reverse_axis:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.reverse_axis
                    : null,
            show_y_scroll:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.show_y_scroll
                    : null,
            enable_labels:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.enable_labels
                    : null,
            enable_grid:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.enable_grid
                    : null,
            origin_display_field:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.origin_display_field
                    : null,
            link_display_field:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.link_display_field
                    : null,
            legend_direction:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.legend_direction
                    : null,
            layout:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.layout
                    : 'table',
            period:
                this.props.item && this.props.item.settings
                    ? this.props.item.settings.period
                    : null,
            availableRoles: [],
            parent: this.props.item ? this.props.item.parent_id : null,
            item: this.props.item
                ? {
                      id: this.props.item.id,
                      translations: this.props.item.translations,
                      defDossier: this.props.item.def_dossier_id,
                      dossierQuery: this.props.item.dossier_query_id,
                      roles: this.props.item.roles.map((item) => item.role_id),
                      col: this.props.item.col,
                      rank: this.props.item.rank,
                      dashboard: this.props.item.dashboard,
                      type: this.props.item.type,
                      settings: this.props.item.settings
                          ? this.props.item.settings
                          : {},
                  }
                : {
                      type: 'dashboard',
                      col: 0,
                      rank: 0,
                      defDossier: null,
                      translations: [],
                      roles: [],
                      dashboard: true,
                      settings: {},
                  },
            submitting: false,
            activeTab: 'general',
        }

        this.handleErrors = this.handleErrors.bind(this)
        this.handleSuccess = this.handleSuccess.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleTemplateOptionsChange =
            this.handleTemplateOptionsChange.bind(this)
        this.handleNormalChange = this.handleNormalChange.bind(this)
        this.handleChangeVar = this.handleChangeVar.bind(this)
        this.onChangeTranslation = this.onChangeTranslation.bind(this)
        this.submit = this.submit.bind(this)
        this.onChangeRole = this.onChangeRole.bind(this)
        this.renderSettingsByType = this.renderSettingsByType.bind(this)
    }

    onChangeTranslation(locale, title) {
        let myPageBlock = this.state.item

        if (!myPageBlock.translations || myPageBlock.translations.length <= 0) {
            myPageBlock.translations = []
        }

        let trans = myPageBlock.translations.find(
            (item) => item.culture === locale
        )
        let translations = myPageBlock.translations.filter(
            (item) => item.culture !== locale
        )

        myPageBlock.translations = translations
        if (!trans) {
            trans = { culture: locale, title: title }
        } else {
            trans.title = title
        }
        translations.push(trans)
        myPageBlock.translations = translations

        this.setState({ item: myPageBlock })
    }

    /**
     * @param response
     * @returns {boolean}
     */
    hasFormErrors(response) {
        if (
            response.response &&
            response.response.status === 400 &&
            response.response.data &&
            response.response.data.errors
        ) {
            return true
        }

        return false
    }

    async fetchRoles() {
        const { kedo } = this.props

        const environment = kedo.env().getEnvironment()

        this.setState({ loading: true })

        try {
            const response = await kedo
                .api()
                .get(kedo.api().getRoleEndpoint(), {
                    params: {
                        environment: environment.id,
                        limit: 200,
                    },
                })

            const availableRoles = response.data.results
            const currentRoles = environment.roles
            const item = { ...this.state.item }

            if (!kedo.isAdminOrEnvironmentAdmin()) {
                item.roles = availableRoles
                    .filter((role) =>
                        currentRoles.some((item) => item.id === role.id)
                    )
                    .map((rol) => rol.id)
            }

            this.setState({
                availableRoles,
                item,
                loading: false,
            })
        } catch (error) {
            this.setState({ loading: false })
        }
    }

    fetchCustomViews() {
        const api = this.props.kedo.api()
        this.setState({ loading: true })
        api.get(api.getDisplayCustomViewEndpoint(), {
            params: {
                environment: this.props.kedo.env().getEnvironment().id,
                defDossier: this.state.item.defDossier,
                limit: 200,
            },
        }).then((response) =>
            this.setState({
                loading: false,
                views: response.data.results,
            })
        )
    }

    fetchQueries() {
        const api = this.props.kedo.api()
        this.setState({ loading: true })
        api.get(api.getDossierQueryEndpoint(), {
            params: {
                environment: this.props.kedo.env().getEnvironment().id,
                defDossier: this.state.item.defDossier,
                limit: 200,
            },
        }).then((response) =>
            this.setState({
                loading: false,
                dossierQueries: response.data.results,
            })
        )
    }

    fetchDefDossiers() {
        const api = this.props.kedo.api()
        this.setState({ loading: true })
        api.getCached(api.getDefDossierEndpoint(), {
            params: {
                environment: this.props.kedo.env().getEnvironment().id,
                limit: 200,
            },
        }).then((response) =>
            this.setState({
                loading: false,
                defDossiers: response.data.results,
            })
        )
    }

    handleSuccess() {
        this.setState({
            submitting: false,
            item: {},
            errors: false,
        })
        this.props.onSuccess(true)
    }

    handleErrors(response) {
        if (!this.hasFormErrors(response)) {
            this.setState({
                submitting: false,
                errors: {
                    generic: this.props.kedo.t('Something went wrong'),
                },
            })
        }
        this.setState({
            submitting: false,
            errors: response.response.data.errors,
        })
    }

    renderErrorFeedback(errorMsg) {
        if (!errorMsg) {
            return
        }

        return <FormHelperText error>{errorMsg}</FormHelperText>
    }

    handleNormalChange(event) {
        this.setState({ [event.target.name]: event.target.value })
    }

    handleChangeVar(key, val) {
        this.setState({ [key]: val })
    }

    handleTemplateOptionsChange(fieldName, fieldValue) {
        let templateOptions = this.state.templateOptions
        if (!templateOptions) {
            templateOptions = {}
        }
        templateOptions[fieldName] = fieldValue
        this.setState({ templateOptions: templateOptions })
    }

    handleChange(event) {
        let item = this.state.item
        item[event.target.name] = event.target.value
        this.setState({ item: item })
    }

    submit() {
        const kedo = this.props.kedo

        if (
            !this.state.item.type ||
            (![
                'online_users',
                'funnel',
                'active_users',
                'kedo_charts',
                'new_dossier_statistics',
                'block_container',
            ].includes(this.state.item.type) &&
                !this.state.item.defDossier)
        ) {
            let errors = {}
            if (!this.state.item.type || this.state.item.type.length <= 0) {
                errors.type = kedo.t('This is a required field')
            }
            if (
                !this.state.item.defDossier ||
                this.state.item.defDossier.length <= 0
            ) {
                errors.defDossier = kedo.t('This is a required field')
            }

            this.setState({ errors: errors })
            return
        }

        this.setState({
            submitting: true,
            errors: false,
        })

        let baseUrl = kedo.api().getMyPageBlockEndpoint()
        let settings = {
            limit: this.state.limit,
            scheme: this.state.scheme,
        }

        if (this.state.item.type === 'dashboard') {
            settings.view_name = this.state.view_name
            settings.layout = this.state.layout
            settings.show_add = this.state.showAdd
            settings.tab_queries = this.state.tabQueries
            settings.carousel = this.state.carousel
            settings.template = this.state.template
            settings.sort = this.state.sort
            settings.templateOptions = this.state.templateOptions
        } else if (
            this.state.item.type === 'list_option_percentage_conditions'
        ) {
            settings.pie_charts = this.state.pie_charts
        } else if (this.state.item.type === 'count_list_options') {
            settings.count_list_field = this.state.count_list_field
            settings.date_field = this.state.date_field
            settings.use_creation_date = this.state.use_creation_date
            settings.date_format = this.state.date_format
            settings.chart_format = this.state.chart_format
            settings.group_format = this.state.group_format
            settings.chart_layout = this.state.chart_layout
            settings.table_layout = this.state.table_layout
            settings.reverse_axis = this.state.reverse_axis
            settings.show_y_scroll = this.state.show_y_scroll
            settings.enable_labels = this.state.enable_labels
            settings.enable_grid = this.state.enable_grid
            settings.legend_direction = this.state.legend_direction
            settings.scheme = this.state.scheme
        } else if (this.state.item.type === 'sum_fields') {
            settings.sum_field = this.state.sum_field
            settings.scheme = this.state.scheme
        } else if (this.state.item.type === 'kedo_charts') {
            settings.chart_layout = this.state.chart_layout
            settings.chart_identifier = this.state.chart_identifier
        } else if (this.state.item.type === 'block_container') {
            settings.layout =
                !this.state.layout || this.state.layout === 'table'
                    ? 'horizontal'
                    : this.state.layout
        } else if (this.state.item.type === 'date_statistics') {
            settings.scheme = this.state.scheme
            settings.link_field = this.state.link_field
            settings.list_field = this.state.list_field
            settings.period = this.state.period
            settings.date_field = this.state.date_field
        } else if (this.state.item.type === 'count_link_options') {
            settings.date_field = this.state.date_field
            settings.date_format = this.state.date_format
            settings.use_creation_date = this.state.use_creation_date
            settings.chart_format = this.state.chart_format
            settings.group_format = this.state.group_format
            settings.chart_layout = this.state.chart_layout
            settings.table_layout = this.state.table_layout
            settings.reverse_axis = this.state.reverse_axis
            settings.link_display_field = this.state.link_display_field
            settings.count_link_field_sec = this.state.count_link_field_sec
            settings.origin_link_field = this.state.origin_link_field
            settings.show_y_scroll = this.state.show_y_scroll
            settings.origin_display_field = this.state.origin_display_field
            settings.count_link_field = this.state.count_link_field
            settings.scheme = this.state.scheme
        } else if (this.state.item.type === 'geomap') {
            //TODO
        } else if (this.state.item.type === 'funnel') {
            //TODO
        } else {
            settings.scheme = this.state.scheme
        }

        let item = {
            translations: this.state.item.translations,
            settings: settings,
            parent: this.state.parent,
            type: this.state.item.type,
            col: this.state.item.col,
            defDossier: this.state.item.defDossier,
            dashboard: this.state.item.dashboard,
            rank: this.state.item.rank,
            dossierQuery: this.state.item.dossierQuery,
            roles: this.state.item.roles,
        }
        if (this.state.item.id) {
            kedo.api()
                .patch(baseUrl + '/' + this.props.item.id, item)
                .then(() => this.handleSuccess())
                .catch((errResponse) => this.handleErrors(errResponse))
        } else {
            item.environment = kedo.env().getEnvironment().id
            item.uuid = kedo.utils().uuidv4()

            kedo.api()
                .post(baseUrl, item)
                .then(() => this.handleSuccess())
                .catch((errResponse) => this.handleErrors(errResponse))
        }
    }

    onChangeRole(e) {
        let item = this.state.item
        item.roles = item.roles.filter((roleId) => e.target.value != roleId)

        if (e.target.checked) {
            item.roles.push(parseInt(e.target.value))
        }

        this.setState({ item: item })
    }

    renderTranslations(translations) {
        if (!translations || translations.length <= 0) {
            translations = []
        }
        let locales = this.props.kedo.env().getEnvironmentLocales()

        if (!locales) {
            return this.props.kedo.t('No languages set')
        }

        if (locales.length === 1) {
            let trans = translations.find(
                (item) => locales[0].code === item.culture
            )
            if (!trans) {
                trans = {}
            }

            return (
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>{this.props.kedo.t('Name')}</FormInputLabel>

                    <TextField
                        value={trans.title || ''}
                        type="text"
                        size="small"
                        onChange={(event) =>
                            this.onChangeTranslation(
                                locales[0].code,
                                event.target.value
                            )
                        }
                    />
                </FormControl>
            )
        }

        return (
            <div className="language_accordion">
                {locales.map((locale) => {
                    let trans =
                        translations.find(
                            (item) => locale.code === item.culture
                        ) || {}

                    return (
                        <Accordion
                            key={locale.id}
                            defaultExpanded={locales[0].id === locale.id}
                        >
                            <AccordionSummary
                                expandIcon={
                                    <FontAwesomeIcon icon={faAngleDown} />
                                }
                                aria-controls={`panel-${locale.id}-content`}
                                id={`panel-${locale.id}-header`}
                                sx={{
                                    backgroundColor:
                                        brandedTokens.variables
                                            .secondaryScale[10],
                                }}
                            >
                                <Typography>
                                    <LocaleName
                                        kedo={this.props.kedo}
                                        localeCode={locale.code}
                                    />
                                </Typography>
                            </AccordionSummary>

                            <AccordionDetails>
                                <TextField
                                    fullWidth
                                    size="small"
                                    margin="dense"
                                    value={trans.title || ''}
                                    onChange={(event) =>
                                        this.onChangeTranslation(
                                            locale.code,
                                            event.target.value
                                        )
                                    }
                                />
                            </AccordionDetails>
                        </Accordion>
                    )
                })}
            </div>
        )
    }

    componentDidMount() {
        this.fetchDefDossiers()
        this.fetchRoles()
        if (this.props.item) {
            this.fetchCustomViews()
        }
    }

    renderSettingsByType(blockType) {
        const kedo = this.props.kedo

        if (blockType === 'list_option_percentage_conditions') {
            if (!this.state.item.defDossier) {
                return ''
            }
            return (
                <>
                    <BlockFormPercentageChartSetting
                        pie_charts={this.state.pie_charts}
                        kedo={kedo}
                        onChange={(pieCharts) =>
                            this.setState({ pie_charts: pieCharts })
                        }
                    />
                    <NivoSchemeSelector
                        kedo={kedo}
                        value={this.state.scheme}
                        onChange={(e) =>
                            this.setState({ scheme: e.target.value })
                        }
                    />
                </>
            )
        } else if (blockType === 'count_link_options') {
            if (!this.state.item.defDossier) {
                return ''
            }
            return (
                <div>
                    <h5>{kedo.t('Date options')}</h5>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>
                            {kedo.t('Date')} <small>{kedo.t('Optional')}</small>
                        </FormInputLabel>
                        <SelectList
                            disableInit={true}
                            currentValue={this.state.date_field}
                            onClear={() => this.setState({ date_field: null })}
                            searchName={'search'}
                            kedo={this.props.kedo}
                            urlParams={{
                                type: 'date',
                                environment: kedo.env().getEnvironment().id,
                                defDossier: this.state.item.defDossier,
                            }}
                            onDisplayName={(item) => item.name}
                            url={kedo.api().getDefDossierDefFieldEndpoint()}
                            onSelect={(item) => {
                                // let settings = this.state.item.settings;
                                // settings.date_field = item.id;
                                this.setState({ date_field: item.id })
                            }}
                        />
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>
                            {kedo.t('Use dossier creation date')}{' '}
                            <small>{kedo.t('Optional')}</small>
                        </FormInputLabel>

                        <FormControlLabel
                            control={
                                <Checkbox
                                    size="small"
                                    id="use_creation_date"
                                    checked={
                                        this.state.use_creation_date === true
                                    }
                                    onChange={(e) => {
                                        this.setState({
                                            use_creation_date: e.target.checked,
                                        })
                                    }}
                                />
                            }
                            label=""
                            sx={{
                                mb: 0,
                                '& .MuiFormControlLabel-label': {
                                    fontSize: '0.875rem',
                                    color: 'text.primary',
                                },
                            }}
                        />
                    </FormControl>
                    <hr />
                    <h5>{kedo.t('Origin options')}</h5>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>
                            {kedo.t('Origin display link field')}
                        </FormInputLabel>
                        <SelectList
                            key={`origin_link_field`}
                            disableInit={true}
                            currentValue={this.state.origin_link_field}
                            onClear={() =>
                                this.setState({ origin_link_field: null })
                            }
                            searchName={'search'}
                            kedo={kedo}
                            urlParams={{
                                page: 0,
                                limit: 200,
                                environment: kedo.env().getEnvironment().id,
                                defDossier: this.state.item.defDossier,
                            }}
                            onDisplayName={(item) => item.name}
                            url={kedo.api().getDefDossierLinkEndpoint()}
                            onUpdateCurrentItem={(item) =>
                                this.setState({
                                    originLinkDefDossier:
                                        item.child_def_dossier_id,
                                })
                            }
                            onSelect={(item) => {
                                this.setState({
                                    origin_link_field: item.id,
                                    originLinkDefDossier:
                                        item.child_def_dossier_id,
                                })
                            }}
                        />
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>
                            {kedo.t('Origin display field')}
                        </FormInputLabel>
                        <SelectList
                            key={`link_display_field`}
                            currentValue={this.state.origin_display_field}
                            onClear={() =>
                                this.setState({ origin_display_field: null })
                            }
                            disableInit={true}
                            searchName={'search'}
                            kedo={kedo}
                            urlParams={{
                                defDossier: this.state.originLinkDefDossier
                                    ? this.state.originLinkDefDossier
                                    : this.state.item.defDossier,
                            }}
                            onDisplayName={(item) => item.name}
                            url={kedo.api().getDefDossierDefFieldEndpoint()}
                            onSelect={(item) =>
                                this.setState({ origin_display_field: item.id })
                            }
                        />
                    </FormControl>
                    <hr />
                    <h5>{kedo.t('Link options')}</h5>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel className={'required'}>
                            {kedo.t('Link field')}
                        </FormInputLabel>
                        <SelectList
                            key={`count_link_field`}
                            currentValue={this.state.count_link_field}
                            onClear={() =>
                                this.setState({ count_link_field: null })
                            }
                            searchName={'search'}
                            kedo={kedo}
                            urlParams={{
                                page: 0,
                                limit: 200,
                                environment: kedo.env().getEnvironment().id,
                                defDossier: this.state.item.defDossier,
                            }}
                            onDisplayName={(item) => item.name}
                            url={kedo.api().getDefDossierLinkEndpoint()}
                            onUpdateCurrentItem={(item) =>
                                this.setState({
                                    countLinkDefDossier:
                                        item.child_def_dossier_id,
                                })
                            }
                            onSelect={(item) => {
                                this.setState({
                                    count_link_field: item.id,
                                    countLinkDefDossier:
                                        item.child_def_dossier_id,
                                })
                            }}
                        />
                    </FormControl>
                    {this.state.countLinkDefDossier ? (
                        <FormControl fullWidth margin="normal">
                            <FormInputLabel>
                                {kedo.t('Second link field')}
                            </FormInputLabel>
                            <SelectList
                                key={`count_link_field_sec`}
                                disableInit={true}
                                currentValue={this.state.count_link_field_sec}
                                onClear={() =>
                                    this.setState({
                                        count_link_field_sec: null,
                                    })
                                }
                                searchName={'search'}
                                kedo={kedo}
                                urlParams={{
                                    page: 0,
                                    limit: 200,
                                    environment: kedo.env().getEnvironment().id,
                                    defDossier: this.state.countLinkDefDossier,
                                }}
                                onDisplayName={(item) => item.name}
                                url={kedo.api().getDefDossierLinkEndpoint()}
                                onUpdateCurrentItem={(item) =>
                                    this.setState({
                                        countLinkDefDossierSec:
                                            item.child_def_dossier_id,
                                    })
                                }
                                onSelect={(item) => {
                                    this.setState({
                                        count_link_field_sec: item.id,
                                        countLinkDefDossierSec:
                                            item.child_def_dossier_id,
                                    })
                                }}
                            />
                        </FormControl>
                    ) : null}
                    <NivoSchemeSelector
                        kedo={kedo}
                        value={this.state.scheme}
                        onChange={(e) =>
                            this.setState({ scheme: e.target.value })
                        }
                    />
                    {this.state.countLinkDefDossier ||
                    this.state.countLinkDefDossierSec ? (
                        <FormControl fullWidth margin="normal">
                            <FormInputLabel>
                                {kedo.t('Link display field')}
                            </FormInputLabel>
                            <SelectList
                                key={`link_display_field`}
                                currentValue={this.state.link_display_field}
                                onClear={() =>
                                    this.setState({ link_display_field: null })
                                }
                                disableInit={true}
                                searchName={'search'}
                                kedo={kedo}
                                urlParams={{
                                    defDossier: this.state
                                        .countLinkDefDossierSec
                                        ? this.state.countLinkDefDossierSec
                                        : this.state.countLinkDefDossier,
                                }}
                                onDisplayName={(item) => item.name}
                                url={kedo.api().getDefDossierDefFieldEndpoint()}
                                onSelect={(item) =>
                                    this.setState({
                                        link_display_field: item.id,
                                    })
                                }
                            />
                        </FormControl>
                    ) : null}
                    <hr />
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>{kedo.t('Date format')}</FormInputLabel>
                        <Select
                            name="date_format"
                            value={this.state.date_format || ''}
                            displayEmpty
                            size="small"
                            onChange={this.handleNormalChange}
                        >
                            <MenuItem value="">
                                {kedo.t('Choose an option')}
                            </MenuItem>
                            <MenuItem value="year_month">
                                {kedo.t('Year month')}
                            </MenuItem>
                            <MenuItem value="quarter">
                                {kedo.t('Quarters')}
                            </MenuItem>
                            <MenuItem value="year">{kedo.t('Year')}</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>
                            {kedo.t('Chart format')}
                        </FormInputLabel>
                        <Select
                            name="chart_format"
                            size="small"
                            value={this.state.chart_format || ''}
                            displayEmpty
                            onChange={this.handleNormalChange}
                        >
                            <MenuItem value="">
                                {kedo.t('Choose an option')}
                            </MenuItem>
                            <MenuItem value="line">{kedo.t('Line')}</MenuItem>
                            <MenuItem value="bar">{kedo.t('Bar')}</MenuItem>
                            <MenuItem value="pie">{kedo.t('Pie')}</MenuItem>
                            <MenuItem value="table">{kedo.t('Table')}</MenuItem>
                        </Select>
                    </FormControl>

                    {this.state.chart_format === 'bar' && (
                        <FormControl fullWidth margin="normal">
                            <FormInputLabel>
                                {kedo.t('Group format')}
                            </FormInputLabel>
                            <Select
                                name="group_format"
                                size="small"
                                value={this.state.group_format || ''}
                                displayEmpty
                                onChange={this.handleNormalChange}
                            >
                                <MenuItem value="">
                                    {kedo.t('Choose an option')}
                                </MenuItem>
                                <MenuItem value="grouped">
                                    {kedo.t('Grouped')}
                                </MenuItem>
                                <MenuItem value="stacked">
                                    {kedo.t('Stacked')}
                                </MenuItem>
                            </Select>
                        </FormControl>
                    )}

                    {this.state.chart_format === 'bar' && (
                        <FormControl fullWidth margin="normal">
                            <FormInputLabel>
                                {kedo.t('Chart layout')}
                            </FormInputLabel>
                            <Select
                                name="chart_layout"
                                size="small"
                                value={this.state.chart_layout || ''}
                                displayEmpty
                                onChange={this.handleNormalChange}
                            >
                                <MenuItem value="">
                                    {kedo.t('Choose an option')}
                                </MenuItem>
                                <MenuItem value="vertical">
                                    {kedo.t('Vertical')}
                                </MenuItem>
                                <MenuItem value="horizontal">
                                    {kedo.t('Horizontal')}
                                </MenuItem>
                            </Select>
                        </FormControl>
                    )}
                    {this.state.chart_format === 'table' && (
                        <FormControl fullWidth margin="normal">
                            <FormInputLabel>
                                {kedo.t('Table layout')}
                            </FormInputLabel>
                            <Select
                                name="table_layout"
                                size="small"
                                value={this.state.table_layout || ''}
                                displayEmpty
                                onChange={this.handleNormalChange}
                            >
                                <MenuItem value="">
                                    {kedo.t('Choose an option')}
                                </MenuItem>
                                <MenuItem value="ver1">
                                    {kedo.t('Version 1 (Martinique header)')}
                                </MenuItem>
                                <MenuItem value="ver2">
                                    {kedo.t(
                                        'Version 2 (Dark header/green striped)'
                                    )}
                                </MenuItem>
                                <MenuItem value="ver3">
                                    {kedo.t('Version 3 (Havelock Blue)')}
                                </MenuItem>
                                <MenuItem value="ver4">
                                    {kedo.t('Version 4 (Red)')}
                                </MenuItem>
                                <MenuItem value="ver5">
                                    {kedo.t(
                                        'Version 5 (Dark header/light blue striped)'
                                    )}
                                </MenuItem>
                                <MenuItem value="ver6">
                                    {kedo.t('Version 6 (Purple)')}
                                </MenuItem>
                            </Select>
                        </FormControl>
                    )}
                    {this.state.chart_format === 'table' && (
                        <FormControl fullWidth margin="normal">
                            <FormInputLabel>
                                {kedo.t('Reverse axis')}
                            </FormInputLabel>
                            <Select
                                name="reverse_axis"
                                size="small"
                                value={this.state.reverse_axis || ''}
                                displayEmpty
                                onChange={this.handleNormalChange}
                            >
                                <MenuItem value="">
                                    {kedo.t('Choose an option')}
                                </MenuItem>
                                <MenuItem value="no">{kedo.t('no')}</MenuItem>
                                <MenuItem value="yes">{kedo.t('yes')}</MenuItem>
                            </Select>
                        </FormControl>
                    )}

                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>
                            {kedo.t('Show Y scrollbars')}
                        </FormInputLabel>
                        <Select
                            name="show_y_scroll"
                            size="small"
                            value={this.state.show_y_scroll || ''}
                            displayEmpty
                            onChange={this.handleNormalChange}
                        >
                            <MenuItem value="">
                                {kedo.t('Choose an option')}
                            </MenuItem>
                            <MenuItem value="no">{kedo.t('no')}</MenuItem>
                            <MenuItem value="yes">{kedo.t('yes')}</MenuItem>
                        </Select>
                    </FormControl>
                </div>
            )
        } else if (blockType === 'count_list_options') {
            if (!this.state.item.defDossier) {
                return ''
            }
            return (
                <div>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel className={'required'}>
                            {kedo.t('List field')}
                        </FormInputLabel>
                        <SelectList
                            currentValue={this.state.count_list_field}
                            onClear={() =>
                                this.setState({ count_list_field: null })
                            }
                            searchName={'search'}
                            kedo={this.props.kedo}
                            urlParams={{
                                page: 0,
                                limit: 200,
                                type: 'list',
                                environment: kedo.env().getEnvironment().id,
                                defDossier: this.state.item.defDossier,
                            }}
                            onDisplayName={(item) => item.name}
                            url={kedo.api().getDefDossierDefFieldEndpoint()}
                            onSelect={(item) => {
                                this.setState({ count_list_field: item.id })
                            }}
                        />
                    </FormControl>
                    <NivoSchemeSelector
                        kedo={kedo}
                        value={this.state.scheme}
                        onChange={(e) =>
                            this.setState({ scheme: e.target.value })
                        }
                    />
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>
                            {kedo.t('Date')} <small>{kedo.t('Optional')}</small>
                        </FormInputLabel>
                        <SelectList
                            currentValue={this.state.date_field}
                            onClear={() => this.setState({ date_field: null })}
                            searchName={'search'}
                            kedo={this.props.kedo}
                            urlParams={{
                                type: 'date',
                                environment: kedo.env().getEnvironment().id,
                                defDossier: this.state.item.defDossier,
                            }}
                            onDisplayName={(item) => item.name}
                            url={kedo.api().getDefDossierDefFieldEndpoint()}
                            onSelect={(item) => {
                                // let settings = this.state.item.settings;
                                // settings.date_field = item.id;
                                this.setState({ date_field: item.id })
                            }}
                        />
                    </FormControl>
                    <FormControl variant="standard" fullWidth margin="normal">
                        <FormInputLabel>
                            {kedo.t('Use dossier creation date')}{' '}
                            <small>{kedo.t('Optional')}</small>
                        </FormInputLabel>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    size="small"
                                    id="use_creation_date"
                                    checked={
                                        this.state.use_creation_date === true
                                    }
                                    onChange={(e) => {
                                        this.setState({
                                            use_creation_date: e.target.checked,
                                        })
                                    }}
                                />
                            }
                            label=""
                            sx={{
                                mb: 0,
                                '& .MuiFormControlLabel-label': {
                                    fontSize: '0.875rem',
                                    color: 'text.primary',
                                },
                            }}
                        />
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel id="date_format_label">
                            {kedo.t('Date format')}
                        </FormInputLabel>
                        <Select
                            labelId="date_format_label"
                            id="date_format"
                            name="date_format"
                            size="small"
                            value={this.state.date_format}
                            onChange={this.handleNormalChange}
                            displayEmpty
                        >
                            <MenuItem value="">
                                {kedo.t('Choose an option')}
                            </MenuItem>
                            <MenuItem value="year_month">
                                {kedo.t('Year month')}
                            </MenuItem>
                            <MenuItem value="quarter">
                                {kedo.t('Quarters')}
                            </MenuItem>
                            <MenuItem value="year">{kedo.t('Year')}</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel id="chart_format_label">
                            {kedo.t('Chart format')}
                        </FormInputLabel>
                        <Select
                            labelId="chart_format_label"
                            id="chart_format"
                            name="chart_format"
                            size="small"
                            value={this.state.chart_format}
                            onChange={this.handleNormalChange}
                            displayEmpty
                        >
                            <MenuItem value="">
                                {kedo.t('Choose an option')}
                            </MenuItem>
                            <MenuItem value="line">{kedo.t('Line')}</MenuItem>
                            <MenuItem value="bar">{kedo.t('Bar')}</MenuItem>
                            <MenuItem value="pie">{kedo.t('Pie')}</MenuItem>
                            <MenuItem value="table">{kedo.t('Table')}</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel id="group_format_label">
                            {kedo.t('Group format')}
                        </FormInputLabel>
                        <Select
                            labelId="group_format_label"
                            id="group_format"
                            name="group_format"
                            size="small"
                            value={this.state.group_format}
                            onChange={this.handleNormalChange}
                            displayEmpty
                        >
                            <MenuItem value="">
                                {kedo.t('Choose an option')}
                            </MenuItem>
                            <MenuItem value="grouped">
                                {kedo.t('Grouped')}
                            </MenuItem>
                            <MenuItem value="stacked">
                                {kedo.t('Stacked')}
                            </MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel id="chart_layout_label">
                            {kedo.t('Chart layout')}
                        </FormInputLabel>
                        <Select
                            labelId="chart_layout_label"
                            id="chart_layout"
                            name="chart_layout"
                            size="small"
                            value={this.state.chart_layout}
                            onChange={this.handleNormalChange}
                            displayEmpty
                        >
                            <MenuItem value="">
                                {kedo.t('Choose an option')}
                            </MenuItem>
                            <MenuItem value="vertical">
                                {kedo.t('Vertical')}
                            </MenuItem>
                            <MenuItem value="horizontal">
                                {kedo.t('Horizontal')}
                            </MenuItem>
                        </Select>
                    </FormControl>
                    {this.state.chart_format === 'table' && (
                        <FormControl fullWidth margin="normal">
                            <FormInputLabel id="reverse_axis_label">
                                {kedo.t('Reverse axis')}
                            </FormInputLabel>
                            <Select
                                labelId="reverse_axis_label"
                                id="reverse_axis"
                                name="reverse_axis"
                                size="small"
                                value={this.state.reverse_axis}
                                onChange={this.handleNormalChange}
                                displayEmpty
                            >
                                <MenuItem value="">
                                    {kedo.t('Choose an option')}
                                </MenuItem>
                                <MenuItem value="no">{kedo.t('no')}</MenuItem>
                                <MenuItem value="yes">{kedo.t('yes')}</MenuItem>
                            </Select>
                        </FormControl>
                    )}
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel id="enable_labels_label">
                            {kedo.t('Enable Label')}
                        </FormInputLabel>
                        <Select
                            labelId="enable_labels_label"
                            id="enable_labels"
                            name="enable_labels"
                            size="small"
                            value={this.state.enable_labels}
                            onChange={this.handleNormalChange}
                            displayEmpty
                        >
                            <MenuItem value="">
                                {kedo.t('Choose an option')}
                            </MenuItem>
                            <MenuItem value="no">{kedo.t('no')}</MenuItem>
                            <MenuItem value="yes">{kedo.t('yes')}</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel id="enable_grid_label">
                            {kedo.t('Enable Grid')}
                        </FormInputLabel>
                        <Select
                            labelId="enable_grid_label"
                            id="enable_grid"
                            name="enable_grid"
                            size="small"
                            value={this.state.enable_grid}
                            onChange={this.handleNormalChange}
                            displayEmpty
                        >
                            <MenuItem value="">
                                {kedo.t('Choose an option')}
                            </MenuItem>
                            <MenuItem value="no">{kedo.t('no')}</MenuItem>
                            <MenuItem value="yes">{kedo.t('yes')}</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel id="show_y_scroll_label">
                            {kedo.t('Show Y scrollbars')}
                        </FormInputLabel>
                        <Select
                            labelId="show_y_scroll_label"
                            id="show_y_scroll"
                            name="show_y_scroll"
                            size="small"
                            value={this.state.show_y_scroll}
                            onChange={this.handleNormalChange}
                            displayEmpty
                        >
                            <MenuItem value="">
                                {kedo.t('Choose an option')}
                            </MenuItem>
                            <MenuItem value="no">{kedo.t('no')}</MenuItem>
                            <MenuItem value="yes">{kedo.t('yes')}</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel id="reverse_axis_label">
                            {kedo.t('Reverse axis')}
                        </FormInputLabel>
                        <Select
                            labelId="reverse_axis_label"
                            id="reverse_axis"
                            name="reverse_axis"
                            size="small"
                            value={this.state.reverse_axis}
                            onChange={this.handleNormalChange}
                            displayEmpty
                        >
                            <MenuItem value="">
                                {kedo.t('Choose an option')}
                            </MenuItem>
                            <MenuItem value="no">{kedo.t('no')}</MenuItem>
                            <MenuItem value="yes">{kedo.t('yes')}</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel id="legend_direction_label">
                            {kedo.t('Legend direction')}
                        </FormInputLabel>
                        <Select
                            labelId="legend_direction_label"
                            id="legend_direction"
                            name="legend_direction"
                            size="small"
                            value={this.state.legend_direction}
                            onChange={this.handleNormalChange}
                            displayEmpty
                        >
                            <MenuItem value="">
                                {kedo.t('Choose an option')}
                            </MenuItem>
                            <MenuItem value="left-to-right">
                                {kedo.t('left-to-right')}
                            </MenuItem>
                            <MenuItem value="right-to-left">
                                {kedo.t('right-to-left')}
                            </MenuItem>
                            <MenuItem value="top-to-bottom">
                                {kedo.t('top-to-bottom')}
                            </MenuItem>
                            <MenuItem value="bottom-to-top">
                                {kedo.t('bottom-to-top')}
                            </MenuItem>
                        </Select>
                    </FormControl>
                </div>
            )
        } else if (blockType === 'dashboard') {
            return (
                <>
                    {this.state.showAddView ? (
                        <DisplayCustomViewForm
                            onSuccess={() => {
                                this.setState({ showAddView: false })
                                setTimeout(() => this.fetchCustomViews(), 50)
                            }}
                            onClose={() =>
                                this.setState({ showAddView: false })
                            }
                            kedo={this.props.kedo}
                            defDossierId={this.state.item.defDossier}
                        />
                    ) : null}
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel
                            className="required"
                            id="view_name_label"
                        >
                            {kedo.t('View')}
                        </FormInputLabel>
                        <Box
                            sx={{
                                display: 'flex',
                                gap: 1,
                                alignItems: 'center',
                            }}
                        >
                            <Select
                                labelId="view_name_label"
                                id="view_name"
                                name="view_name"
                                size="small"
                                value={this.state.view_name}
                                onChange={this.handleNormalChange}
                            >
                                <MenuItem value="">
                                    {kedo.t('Choose an option')}
                                </MenuItem>
                                <MenuItem value="list">
                                    {kedo.t('List')}
                                </MenuItem>
                                {this.state.views.map((displayView) => (
                                    <MenuItem
                                        key={displayView.id}
                                        value={displayView.view_name}
                                    >
                                        {displayView.view_name}
                                    </MenuItem>
                                ))}
                            </Select>
                            <StyledButton
                                onClick={() =>
                                    this.setState({ showAddView: true })
                                }
                            >
                                <FontAwesomeIcon icon={faPlus} />
                            </StyledButton>
                        </Box>
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>{kedo.t('Limit')}</FormInputLabel>
                        <TextField
                            id="limit"
                            name="limit"
                            type="number"
                            size="small"
                            value={this.state.limit}
                            onChange={this.handleNormalChange}
                        />
                    </FormControl>
                    <FormControlLabel
                        control={
                            <Checkbox
                                id="show-add"
                                checked={this.state.showAdd}
                                onChange={(e) =>
                                    this.setState({ showAdd: e.target.checked })
                                }
                            />
                        }
                        label={kedo.t('Show add buttons')}
                        sx={{
                            mb: 0,
                            '& .MuiFormControlLabel-label': {
                                fontSize: '0.875rem',
                                color: 'text.primary',
                            },
                        }}
                    />

                    <BlockTabQueries
                        kedo={kedo}
                        tabQueries={this.state.tabQueries}
                        dossierQueries={this.state.dossierQueries}
                        addTabQuery={() => {
                            let tabQueries = this.state.tabQueries
                            if (!Array.isArray(tabQueries)) {
                                tabQueries = []
                            }
                            tabQueries.push({ query: null, title: '' })
                            this.setState({ tabQueries: tabQueries })
                        }}
                        onChangeTabQueries={(item, i, name, value) => {
                            let tabQueries = this.state.tabQueries
                            tabQueries[i] = item
                            tabQueries[i][name] = value

                            this.setState({ tabQueries: tabQueries })
                        }}
                        deleteTabQuery={(i) => {
                            let tabQueries = this.state.tabQueries
                            tabQueries.splice(i, 1)
                            this.setState({ tabQueries: tabQueries })
                        }}
                    />
                    <BlockFormTemplateSelect
                        handleTemplateOptionsChange={
                            this.handleTemplateOptionsChange
                        }
                        layout={this.state.layout}
                        view_name={this.state.view_name}
                        template={this.state.template}
                        templateOptions={this.state.templateOptions}
                        defDossier={this.state.item.defDossier}
                        handleNormalChange={this.handleNormalChange}
                        handleChangeVar={this.handleChangeVar}
                        kedo={this.props.kedo}
                    />
                </>
            )
        } else if (blockType === 'sum_fields') {
            return (
                <>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>{kedo.t('Sum field')}</FormInputLabel>
                        <SelectList
                            currentValue={this.state.sum_field}
                            onClear={() => this.setState({ sum_field: null })}
                            searchName={'search'}
                            kedo={this.props.kedo}
                            urlParams={{
                                type: 'amount',
                                environment: kedo.env().getEnvironment().id,
                                defDossier: this.state.item.defDossier,
                            }}
                            onDisplayName={(item) => item.name}
                            url={kedo.api().getDefDossierDefFieldEndpoint()}
                            onSelect={(item) => {
                                let settings = this.state.item.settings
                                settings.sum_field = item.id
                                this.setState({
                                    sum_field: item.id,
                                    settings: settings,
                                })
                            }}
                        />
                    </FormControl>
                </>
            )
        } else if (blockType === 'online_users') {
            return (
                <div>
                    <NivoSchemeSelector
                        kedo={kedo}
                        value={this.state.scheme}
                        onChange={(e) =>
                            this.setState({ scheme: e.target.value })
                        }
                    />
                </div>
            )
        } else if (blockType === 'active_users') {
            return (
                <div>
                    <NivoSchemeSelector
                        kedo={kedo}
                        value={this.state.scheme}
                        onChange={(e) =>
                            this.setState({ scheme: e.target.value })
                        }
                    />
                </div>
            )
        } else if (blockType === 'block_container') {
            return (
                <div>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>{kedo.t('Layout')}</FormInputLabel>
                        <Select
                            labelId="layout_label"
                            id="layout"
                            name="layout"
                            size="small"
                            value={this.state.layout}
                            onChange={this.handleNormalChange}
                            displayEmpty
                        >
                            <MenuItem value="">
                                {kedo.t('Choose an option')}
                            </MenuItem>
                            <MenuItem value="horizontal">
                                {kedo.t('horizontal')}
                            </MenuItem>
                            <MenuItem value="vertical">
                                {kedo.t('vertical')}
                            </MenuItem>
                            <MenuItem value="carousel">
                                {kedo.t('carousel')}
                            </MenuItem>
                            <MenuItem value="accordion">
                                {kedo.t('accordion')}
                            </MenuItem>
                        </Select>
                    </FormControl>
                </div>
            )
        } else if (blockType === 'kedo_charts') {
            return (
                <div>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>{kedo.t('Chart type')}</FormInputLabel>
                        <Select
                            labelId="chart_layout_label"
                            id="chart_layout"
                            name="chart_layout"
                            size="small"
                            value={this.state.chart_layout}
                            onChange={this.handleNormalChange}
                            displayEmpty
                        >
                            <MenuItem value="">
                                {kedo.t('Choose an option')}
                            </MenuItem>
                            <MenuItem value="chart">{kedo.t('Chart')}</MenuItem>
                            <MenuItem value="dashboard">
                                {kedo.t('Dashboard')}
                            </MenuItem>
                        </Select>
                        <FormInputLabel>{kedo.t('Identifier')}</FormInputLabel>
                        <TextField
                            id="chart_identifier"
                            name="chart_identifier"
                            value={this.state.chart_identifier}
                            onChange={this.handleNormalChange}
                            size="small"
                            fullWidth
                            margin="normal"
                        />
                    </FormControl>
                </div>
            )
        } else if (blockType === 'new_dossier_statistics') {
            return (
                <div>
                    <NivoSchemeSelector
                        kedo={kedo}
                        value={this.state.scheme}
                        onChange={(e) =>
                            this.setState({ scheme: e.target.value })
                        }
                    />
                </div>
            )
        } else if (blockType === 'date_statistics') {
            return (
                <div>
                    <NivoSchemeSelector
                        kedo={kedo}
                        value={this.state.scheme}
                        onChange={(e) =>
                            this.setState({ scheme: e.target.value })
                        }
                    />
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel className={'required'}>
                            {kedo.t('Period')}
                        </FormInputLabel>
                        <Select
                            labelId="period_label"
                            id="period"
                            name="period"
                            value={this.state.period}
                            onChange={this.handleNormalChange}
                            displayEmpty
                            error={this.state.errors?.period ? true : false}
                        >
                            <MenuItem value="">
                                {kedo.t('Choose an option')}
                            </MenuItem>
                            <MenuItem value="week">{kedo.t('Week')}</MenuItem>
                            <MenuItem value="month">{kedo.t('Month')}</MenuItem>
                            <MenuItem value="year">{kedo.t('Year')}</MenuItem>
                        </Select>
                        {this.renderErrorFeedback(this.state.errors?.period)}
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>{kedo.t('List field')}</FormInputLabel>
                        <SelectList
                            currentValue={this.state.list_field}
                            onClear={() => this.setState({ list_field: null })}
                            searchName={'search'}
                            kedo={this.props.kedo}
                            urlParams={{
                                type: 'list',
                                environment: kedo.env().getEnvironment().id,
                                defDossier: this.state.item.defDossier,
                            }}
                            onDisplayName={(item) => item.name}
                            url={kedo.api().getDefDossierDefFieldEndpoint()}
                            onSelect={(item) => {
                                let settings = this.state.item.settings
                                settings.list_field = item.id
                                this.setState({
                                    list_field: item.id,
                                    settings: settings,
                                })
                            }}
                        />
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <FormInputLabel>
                            {kedo.t('Date')} <small>{kedo.t('Optional')}</small>
                        </FormInputLabel>
                        <SelectList
                            currentValue={this.state.date_field}
                            onClear={() => this.setState({ date_field: null })}
                            searchName={'search'}
                            kedo={this.props.kedo}
                            urlParams={{
                                type: 'date',
                                environment: kedo.env().getEnvironment().id,
                                defDossier: this.state.item.defDossier,
                            }}
                            onDisplayName={(item) => item.name}
                            url={kedo.api().getDefDossierDefFieldEndpoint()}
                            onSelect={(item) => {
                                // let settings = this.state.item.settings;
                                // settings.date_field = item.id;
                                this.setState({ date_field: item.id })
                            }}
                        />
                    </FormControl>
                </div>
            )
        }

        return ''
    }

    render() {
        const kedo = this.props.kedo
        const isEntityRequired = [
            'dashboard',
            'sum_fields',
            'count_list_options',
            'date_statistics',
            'count_link_options',
            'list_option_percentage_conditions',
        ].includes(this.state.item.type)
            ? true
            : false
        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                maxWidth={'xl'}
                fullWidth
                topAlign={true}
                title={
                    <>
                        {kedo.t(this.state.item.id ? 'Edit' : 'Add')}{' '}
                        {kedo.t('Block').toLowerCase()}
                    </>
                }
                onClose={() => this.props.onClose()}
                headerClose={() => this.props.onClose()}
                contentProps={{ dividers: true, dense: true }}
                actions={
                    <>
                        {this.state.delete ? (
                            <ConfirmDeleteDialog
                                errorLabel={kedo.t('Something went wrong')}
                                kedo={kedo}
                                url={
                                    kedo.api().getMyPageBlockEndpoint() +
                                    '/' +
                                    this.state.deleteItem
                                }
                                onClose={() => {
                                    this.setState({ delete: false })
                                    this.fetchItems()
                                }}
                                onSuccess={() => (window.location = '/')}
                            />
                        ) : null}
                        {this.state.item.id ? (
                            <StyledButton
                                sx={{ mr: 'auto' }}
                                onClick={() =>
                                    this.setState({
                                        delete: true,
                                        deleteItem: this.props.item.id,
                                    })
                                }
                                color="error"
                                title={this.props.kedo.t('Delete')}
                                onSucces={() => (window.location = '/')}
                            >
                                <FontAwesomeIcon icon={faTrashAlt} />
                                &nbsp; {this.props.kedo.t('Delete')}
                            </StyledButton>
                        ) : null}
                        <StyledButton onClick={this.submit}>
                            {this.state.submitting ? (
                                <LoadingDefault size={'sm'} as={'span'} />
                            ) : (
                                <FontAwesomeIcon icon={faSave} />
                            )}
                            &nbsp; {kedo.t('Save')}
                        </StyledButton>
                        <StyledButton
                            onClick={() => this.props.onClose()}
                            color="secondary"
                        >
                            {kedo.t('Cancel')}
                        </StyledButton>
                    </>
                }
            >
                <Grid container>
                    <Grid
                        size={3}
                        sx={{
                            borderRight: 1,
                            borderColor: 'divider',
                        }}
                    >
                        <Tabs
                            value={this.state.activeTab}
                            orientation="vertical"
                            onChange={(event, newValue) =>
                                this.setState((prevState) => ({
                                    ...prevState,
                                    activeTab: newValue,
                                }))
                            }
                            sx={{
                                '& .MuiTabs-indicator': {
                                    display: 'none',
                                },
                            }}
                        >
                            <StyledVerticalTab
                                label={
                                    <>
                                        {kedo.t('Generic')}
                                        {this.state.errors != null &&
                                        this.state.errors &&
                                        (this.state.errors.name ||
                                            this.state.errors.type) ? (
                                            <FontAwesomeIcon
                                                className={`validationIcon validationFailed`}
                                                icon={faExclamationCircle}
                                            />
                                        ) : null}
                                    </>
                                }
                                value="general"
                                sx={{
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    gap: 1,
                                    width: '100%',
                                    justifyContent: 'space-between',
                                }}
                            />
                            <StyledVerticalTab
                                label={kedo.t('Layout')}
                                value="layout"
                            />
                            <StyledVerticalTab
                                label={kedo.t('Permissions')}
                                value="permissions"
                            />
                            <StyledVerticalTab
                                label={kedo.t('Sort')}
                                value="sort"
                            />
                            {this.state.item.id ? (
                                <StyledVerticalTab
                                    label={kedo.t('Block type specific')}
                                    value="misc"
                                />
                            ) : null}
                            {this.state.item.id ? (
                                <StyledVerticalTab
                                    label={kedo.t('Info')}
                                    value="info"
                                />
                            ) : null}
                        </Tabs>
                    </Grid>
                    <Grid size={9}>
                        <TabPanel value={this.state.activeTab} index="general">
                            <h3>{kedo.t('Generic')}</h3>
                            {this.renderTranslations(
                                this.state.item.translations
                            )}
                            <br />
                            <FormControl fullWidth margin="normal">
                                <FormInputLabel className="required">
                                    {kedo.t('Type')}
                                </FormInputLabel>
                                <Select
                                    name="type"
                                    value={this.state.item.type || ''}
                                    onChange={this.handleChange}
                                    displayEmpty
                                    size="small"
                                    error={Boolean(this.state.errors?.type)}
                                >
                                    <MenuItem value="">
                                        {kedo.t('Choose an option')}
                                    </MenuItem>

                                    <MenuItem value="dashboard">
                                        {kedo.t('Dashboard')}
                                    </MenuItem>
                                    <MenuItem value="list_option_percentage_conditions">
                                        {kedo.t(
                                            'List options percentage matching condition'
                                        )}
                                    </MenuItem>
                                    <MenuItem value="count_list_options">
                                        {kedo.t('Count list options')}
                                    </MenuItem>
                                    <MenuItem value="count_link_options">
                                        {kedo.t('Count link options')}
                                    </MenuItem>
                                    <MenuItem value="sum_fields">
                                        {kedo.t('Sum amount field')}
                                    </MenuItem>
                                    <MenuItem value="online_users">
                                        {kedo.t('Online users')}
                                    </MenuItem>
                                    <MenuItem value="kedo_charts">
                                        {kedo.t('KeDo charts')}
                                    </MenuItem>
                                    <MenuItem value="active_users">
                                        {kedo.t('Active users')}
                                    </MenuItem>
                                    <MenuItem value="new_dossier_statistics">
                                        {kedo.t('New dossier statistics')}
                                    </MenuItem>
                                    <MenuItem value="date_statistics">
                                        {kedo.t('Date statistics')}
                                    </MenuItem>
                                    <MenuItem value="block_container">
                                        {kedo.t('Block Container')}
                                    </MenuItem>
                                    <MenuItem value="geomap">
                                        {kedo.t('Geomap')}
                                    </MenuItem>
                                    <MenuItem value="funnel">
                                        {kedo.t('Funnel')}
                                    </MenuItem>
                                </Select>
                                {this.renderErrorFeedback(
                                    this.state.errors?.type
                                )}
                            </FormControl>
                            {isEntityRequired ? (
                                <FormControl fullWidth margin="normal">
                                    <FormInputLabel className="required">
                                        {kedo.t('Entity')}
                                    </FormInputLabel>
                                    <Select
                                        name="defDossier"
                                        value={this.state.item.defDossier || ''}
                                        displayEmpty
                                        onChange={(e) => {
                                            this.handleChange(e)
                                            this.fetchCustomViews()
                                        }}
                                        size="small"
                                        error={Boolean(
                                            this.state.errors?.defDossier
                                        )}
                                    >
                                        <MenuItem value="">
                                            {kedo.t('Choose an option')}
                                        </MenuItem>

                                        {this.state.defDossiers.map((item) => (
                                            <MenuItem
                                                key={item.id}
                                                value={item.id}
                                            >
                                                {this.props.kedo
                                                    .env()
                                                    .translateItem(
                                                        item,
                                                        'defdossier'
                                                    )}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {this.renderErrorFeedback(
                                        this.state.errors?.defDossier
                                    )}
                                </FormControl>
                            ) : null}
                            <FormControl fullWidth margin="normal">
                                <FormControlLabel
                                    label={kedo.t('Show on dashboard')}
                                    control={
                                        <Checkbox
                                            name="dashboard"
                                            size="small"
                                            checked={Boolean(
                                                this.state.item.dashboard
                                            )}
                                            disabled={this.state.loading}
                                            onChange={(e) => {
                                                const item = {
                                                    ...this.state.item,
                                                }
                                                item[e.target.name] =
                                                    !this.state.item.dashboard

                                                this.setState({ item })
                                            }}
                                        />
                                    }
                                    sx={{
                                        mb: 0,
                                        '& .MuiFormControlLabel-label': {
                                            fontSize: '0.875rem',
                                            color: 'text.primary',
                                        },
                                    }}
                                />
                            </FormControl>
                            <FormControl fullWidth margin="normal">
                                <FormInputLabel>
                                    {kedo.t('Parent')}
                                </FormInputLabel>
                                <SelectList
                                    currentValue={this.state.parent}
                                    onClear={() =>
                                        this.setState({
                                            parent: null,
                                        })
                                    }
                                    searchName={'search'}
                                    kedo={this.props.kedo}
                                    urlParams={{
                                        page: 0,
                                        limit: 200,
                                        type: 'block_container',
                                        environment: kedo.env().getEnvironment()
                                            .id,
                                    }}
                                    onDisplayName={(item) =>
                                        kedo
                                            .env()
                                            .translateItem(item, 'mypageblock')
                                    }
                                    url={kedo.api().getMyPageBlockEndpoint()}
                                    onSelect={(item) => {
                                        this.setState({
                                            parent: item.id,
                                        })
                                    }}
                                />
                            </FormControl>
                            <FormControl fullWidth margin="normal">
                                <DossierQuerySelect
                                    kedo={kedo}
                                    onChange={(newId) => {
                                        let item = this.state.item
                                        item.dossierQuery = newId
                                        this.setState({
                                            item: item,
                                        })
                                    }}
                                    value={this.state.item?.dossierQuery}
                                    ddId={this.state.item.defDossier}
                                />
                            </FormControl>
                        </TabPanel>
                        <TabPanel value={this.state.activeTab} index="layout">
                            <h3>{kedo.t('Layout')}</h3>
                            <FormControl fullWidth margin="normal">
                                <FormInputLabel>
                                    {kedo.t('Column width')}
                                </FormInputLabel>
                                <TextField
                                    type="number"
                                    name="col"
                                    value={this.state.item.col ?? '12'}
                                    size="small"
                                    error={Boolean(this.state.errors?.col)}
                                    onChange={this.handleChange}
                                    slotProps={{
                                        htmlInput: {
                                            min: 1,
                                            max: 12,
                                        },
                                    }}
                                />

                                <FormHelperText>
                                    {this.props.kedo.t('colspan_message')}
                                </FormHelperText>
                                {this.renderErrorFeedback(
                                    this.state.errors?.col
                                )}
                            </FormControl>
                            <FormControl fullWidth margin="normal">
                                <FormInputLabel>
                                    {kedo.t('Rank')}
                                </FormInputLabel>
                                <TextField
                                    type="number"
                                    name="rank"
                                    size="small"
                                    error={Boolean(this.state.errors?.rank)}
                                    value={this.state.item.rank ?? '0'}
                                    onChange={this.handleChange}
                                />
                                {this.renderErrorFeedback(
                                    this.state.errors?.rank
                                )}
                            </FormControl>
                        </TabPanel>
                        <TabPanel
                            value={this.state.activeTab}
                            index="permissions"
                        >
                            <h3>{kedo.t('Permissions')}</h3>
                            <FormControl fullWidth margin="normal">
                                <FormInputLabel>
                                    {kedo.t('Roles')}
                                </FormInputLabel>

                                <FormGroup>
                                    {this.state.availableRoles.map((item) => (
                                        <FormControlLabel
                                            key={item.id}
                                            label={item.name}
                                            control={
                                                <Checkbox
                                                    id={`role-${item.id}`}
                                                    value={item.id}
                                                    checked={Boolean(
                                                        this.state.item?.roles?.includes(
                                                            item.id
                                                        )
                                                    )}
                                                    onChange={this.onChangeRole}
                                                />
                                            }
                                            sx={{
                                                mb: 0,
                                                '& .MuiFormControlLabel-label':
                                                    {
                                                        fontSize: '0.875rem',
                                                        color: 'text.primary',
                                                    },
                                            }}
                                        />
                                    ))}
                                </FormGroup>
                            </FormControl>
                        </TabPanel>
                        <TabPanel value={this.state.activeTab} index="sort">
                            {this.state.item && this.state.item.defDossier ? (
                                <BlockSortSettings
                                    sort={this.state.sort}
                                    viewName={this.state.view_name}
                                    defDossierId={this.state.item.defDossier}
                                    kedo={this.props.kedo}
                                    onChangeSort={(sortSettings) => {
                                        this.setState({
                                            sort: sortSettings,
                                        })
                                    }}
                                />
                            ) : null}
                        </TabPanel>
                        {this.state.item.id ? (
                            <TabPanel value={this.state.activeTab} index="misc">
                                {this.renderSettingsByType(
                                    this.state.item.type
                                )}
                            </TabPanel>
                        ) : null}
                        {this.state.item.id ? (
                            <TabPanel
                                value={this.state.activeTab}
                                index={'info'}
                            >
                                <ObjectCreatedInfo
                                    item={this.state.item}
                                    kedo={kedo}
                                />
                            </TabPanel>
                        ) : null}
                    </Grid>
                </Grid>
            </AppDialog>
        )
    }
}

export default BlockForm
